(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cart-recommendations')) {
    customElements.define(
      'cart-recommendations',
      class CartRecommendations extends HTMLElement {
        connectedCallback() {
          if (!this.hidden || !this.dataset.url) return

          const sectionWrapper = this.closest('.shopify-section')
          if (sectionWrapper) sectionWrapper.hidden = true

          const intents = (this.dataset.intents || 'related').split(',')

          const requestIntent = (index) => {
            if (index >= intents.length) return

            fetch(`${this.dataset.url}&intent=${intents[index]}`)
              .then((response) => response.text())
              .then((html) => {
                const documentFragment = new DOMParser().parseFromString(html, 'text/html')
                const recommendations = documentFragment.querySelector('[data-cart-recommendations]')

                if (!recommendations || recommendations.hidden || !recommendations.innerHTML.trim()) {
                  requestIntent(index + 1)
                  return
                }

                this.innerHTML = recommendations.innerHTML
                this.hidden = false
                if (sectionWrapper) sectionWrapper.hidden = false
              })
              .catch(() => requestIntent(index + 1))
          }

          requestIntent(0)
        }
      },
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  const positionCollectionFilter = (details) => {
    const panel = details.querySelector('.collection-filter__values, .collection-filter__price-range');
    if (!panel) return;
    panel.style.left = '0px';
    const rect = panel.getBoundingClientRect();
    const shift = Math.max(12 - rect.left, Math.min(0, window.innerWidth - 12 - rect.right));
    panel.style.left = `${shift}px`;
  };

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!details.matches('.collection-filter') || !details.open) return;
    details.closest('form').querySelectorAll('.collection-filter[open]').forEach((other) => {
      if (other !== details) other.open = false;
    });
    positionCollectionFilter(details);
  }, true);

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.collection-filter[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.collection-filter[open]').forEach((details) => {
      details.open = false;
      if (details.contains(document.activeElement)) details.querySelector('summary').focus();
    });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.collection-filter[open]').forEach(positionCollectionFilter);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-signup"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-membership-showcase][data-rotate-on-load="true"]').forEach((showcase) => {
    const previews = Array.from(showcase.querySelectorAll('.membership-signup__preview'))

    if (previews.length <= 2) return

    const shuffled = previews
      .map((preview) => ({ preview, order: Math.random() }))
      .sort((first, second) => first.order - second.order)

    previews.forEach((preview) => {
      preview.hidden = true
    })

    shuffled.slice(0, 2).forEach(({ preview }) => {
      preview.hidden = false
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class ProductRecommendations extends HTMLElement {
        connectedCallback() {
          if (!this.hidden || !this.dataset.url) return

          const sectionWrapper = this.closest('.shopify-section')
          if (sectionWrapper) sectionWrapper.hidden = true

          const intents = (this.dataset.intents || 'related').split(',')

          const requestIntent = (index) => {
            if (index >= intents.length) return

            fetch(`${this.dataset.url}&intent=${intents[index]}`)
              .then((response) => response.text())
              .then((html) => {
                const documentFragment = new DOMParser().parseFromString(html, 'text/html')
                const recommendations = documentFragment.querySelector('[data-product-recommendations]')

                if (!recommendations || recommendations.hidden || !recommendations.innerHTML.trim()) {
                  requestIntent(index + 1)
                  return
                }

                this.innerHTML = recommendations.innerHTML
                this.hidden = false
                if (sectionWrapper) sectionWrapper.hidden = false
              })
              .catch(() => requestIntent(index + 1))
          }

          requestIntent(0)
        }
      },
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-media-target]');
    if (!button) return;
    const page = button.closest('.product-page');
    page.querySelectorAll('[data-product-media]').forEach((panel) => {
      const selected = panel.id === button.dataset.mediaTarget;
      if (!selected) {
        panel.querySelector('deferred-media')?.reset?.();
        panel.querySelectorAll('video').forEach((video) => video.pause());
      }
      panel.hidden = !selected;
    });
    page.querySelectorAll('[data-media-target]').forEach((item) => {
      item.setAttribute('aria-pressed', String(item === button));
    });
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target
    const claimWrapper = form.closest('[data-member-claim]')

    if (!claimWrapper || event.defaultPrevented) return

    event.preventDefault()

    const button = claimWrapper.querySelector('[data-member-claim-button]')
    const errorMessage = claimWrapper.querySelector('[data-member-claim-error]')
    const originalLabel = button.textContent

    button.disabled = true
    button.textContent = claimWrapper.dataset.loadingLabel
    errorMessage.hidden = true

    const formData = new FormData(form)
    const variantId = String(formData.get('id') || '').replace(/\D/g, '')

    if (!variantId) {
      button.disabled = false
      button.textContent = originalLabel
      errorMessage.textContent = claimWrapper.dataset.errorLabel
      errorMessage.hidden = false
      return
    }

    const shopRoot = window.Shopify?.routes?.root || '/'
    const discountCode = encodeURIComponent(claimWrapper.dataset.discountCode)
    window.location.assign(`${shopRoot}cart/${variantId}:1?discount=${discountCode}`)
  })

  } catch(e) { console.error(e); }
})();
})();
